import getNumberOfSharingLinks from './selectors/getNumberOfSharingLinks';
import getSharingDataFromLink from './selectors/getSharingData';
import getSharingLinkInfo from './selectors/getSharingLinkInfo';
import SharingLinkInfo from './store/schema/SharingLinkInfo';
import { LinkActionStatus } from './types/LinkActionStatus';
import { LazyImport, LazyModule } from 'owa-bundling';
import {
    getAnchorElementId,
    getLinkIdFromAnchorElementId,
    isRecipientsOfThisMessagePermission,
} from './utils/getLinkIdFromAnchorElementId';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "LinkData", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded public actions
export const lazyAddRecipientsIntoLink = new LazyImport(lazyModule, m => m.addRecipientsIntoLink);
export const lazyRemoveRecipientsFromLink = new LazyImport(
    lazyModule,
    m => m.removeRecipientsFromLink
);
export const lazyUpdateRecipientPermissionInfos = new LazyImport(
    lazyModule,
    m => m.updateRecipientPermissionInfos
);
export const lazySetGetPermissionInfoFailure = new LazyImport(
    lazyModule,
    m => m.setGetPermissionInfoFailure
);
export const lazyResetSharingRecipientsInfo = new LazyImport(
    lazyModule,
    m => m.resetSharingRecipientsInfo
);

export const lazyIgnoreSharingTip = new LazyImport(lazyModule, m => m.ignoreSharingTip);
export const lazySetLinkActionStatus = new LazyImport(lazyModule, m => m.setLinkActionStatus);

// Delay loaded utility functions
export const lazyGetSharingTipRecipientInfo = new LazyImport(
    lazyModule,
    m => m.getSharingTipRecipientInfo
);

// boot strap - used to load the package, in cases where an action might be fired off before the package is loaded,
// but the action is subbscribed to by other packages, so it can't be lazy loaded directly.
export { lazyModule as preloadLinkData };

// Non-delay loaded subscribable actions
export {
    addSharingLink,
    addSharingLinkToContianer,
    createAttachmentFromLink,
    deleteLink,
    sharingLinkRemoved,
} from './actions/subscribableActions';

// Note - these are actions that are not lazy loaded, and should
// only be consumed by owa-compose-view. They act like internal actions, but
// due to store/view being in different packages must be exported.
export {
    updateSharingLinkFromSharingDialog,
    updateSharingLinkPermission,
    updateSharingLinkUrl,
    setRefreshStatus,
    createSharingLink,
} from './actions/internalActions';

// exported constants types and type guards
export { LinkActionStatus, SharingLinkInfo };
export { RecipientInfo, RecipientPermissionResult } from './types/RecipientPermissionResult';
export { RecipientContainer } from './types/RecipientContainer';
export { recipientContainerIsRecipientWell } from './utils/typeGuards';
export { AnchorElementsSource } from './types/AnchorElementsSource';

// non-delay loaded selectors - TODO make lazy
export {
    getAnchorElementId,
    getLinkIdFromAnchorElementId,
    getNumberOfSharingLinks,
    getSharingDataFromLink,
    getSharingLinkInfo,
    isRecipientsOfThisMessagePermission,
};
